"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberStatusColor = exports.MemberStatus = void 0;
var MemberStatus;
(function (MemberStatus) {
    MemberStatus["Active"] = "active";
    MemberStatus["Inactive"] = "inactive";
    MemberStatus["Pending"] = "pending";
    MemberStatus["Ghost"] = "ghost";
    MemberStatus["Supervisor"] = "supervisor";
    MemberStatus["Moderator"] = "moderator";
    MemberStatus["Banned"] = "banned";
})(MemberStatus = exports.MemberStatus || (exports.MemberStatus = {}));
var MemberStatusColor;
(function (MemberStatusColor) {
    MemberStatusColor["Green"] = "green";
    MemberStatusColor["Yellow"] = "yellow";
    MemberStatusColor["Red"] = "red";
    MemberStatusColor["Gray"] = "gray";
})(MemberStatusColor = exports.MemberStatusColor || (exports.MemberStatusColor = {}));
//# sourceMappingURL=member.js.map